import { NgModule } from "@angular/core";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";


@NgModule({
  imports: [NgxMaterialTimepickerModule],
  exports: [NgxMaterialTimepickerModule]
})
export class ExtraComponentsModule { }